export const showcaseSkills = [
  {
    label: "Javascript",
    rating: 71,
  },
  {
    label: "Node JS",
    rating: 81,
  },
  {
    label: "React",
    rating: 76,
  },
  {
    label: "Mongo dB",
    rating: 72,
  },
  {
    label: "Redux",
    rating: 73,
  },
  {
    label: "Express",
    rating: 74,
  },
  {
    label: "HTML CSS",
    rating: 85,
  },
];

export const frontSkillsList = [
  {
    label: "HTML5",
    src: "https://img.icons8.com/color/480/000000/html-5--v1.png",
  },
  {
    label: "CSS3",
    src: "https://img.icons8.com/color/480/000000/css3.png",
  },
  {
    label: "Javascript",
    src: "https://img.icons8.com/color/480/000000/javascript.png",
  },
  {
    label: "React",
    src: "https://img.icons8.com/color/480/000000/react-native.png",
  },
  {
    label: "Redux",
    src: "https://img.icons8.com/color/480/000000/redux.png",
  },

  {
    label: "Github",
    src: "https://img.icons8.com/fluent/480/000000/github.png",
  },
  {
    label: "NPM",
    src: "https://img.icons8.com/color/480/000000/npm.png",
  },
];

export const backSkillsList = [
  {
    label: "Node JS",
    src: "https://img.icons8.com/color/480/000000/nodejs.png",
  },
  {
    label: "Express JS",
    src: "https://i.ibb.co/9smDM6j/pngegg.png",
  },
  {
    label: "Mongo dB",
    src: "https://i.ibb.co/ZVh01dm/rsz-mong2.png",
  },
];

export const projectsList = [
  {
    label: "OLX Clone",
    imgSrc: "images/olx.jpg",
    src: "https://enormous-library-3081-olx.vercel.app/",
    githubSrc: "https://github.com/Tanmoy-M17/enormous-library-3081",
    description:
      "OLX is the perfect online marketplace to buy and sell locally! No need to visit the flea market to find the best deals on pre-owned items! Here you'll find ...",
    stack: [ "HTML", "CSS","Chakra UI","Bootstrap","React js","Redux"],
  },
  {
    label: "Lumen5 Clone",
    imgSrc: "images/lumen5.jpg",
    src: "https://lumen5-clone.netlify.app/",
    githubSrc: "https://github.com/Aayush771/Lumen-5-Clone",
    description:
      "Lumen5 is a video creation platform powered by A.I. that enables anyone without training or experience to easily create engaging video content within a minute.",
    stack: [ "HTML", "CSS","LOCAL STROAGE"],
  },
  {
    label: "Deyga Clone",
    imgSrc: "images/deyga.jpg",
    src: "https://intense-shore-24711.herokuapp.com/",
    githubSrc: "https://github.com/saumitra-vns/Degya-clone",
    description:
      "Choose from a Wide Range of Natural Cosmetics from India's Favourite Brand. From Start To Finish With Purest Of Ethically Sourced Organic Matter. Easy Returns. 24X7 Customer Service. 100% Natural & Pure. Hand Made Products. Handcrafted with Love.",
    stack: [ "HTML", "CSS","JAVASCRIPT","LOCAL STROAGE","API's"],
  },
  {
    label: "Mini Weather-App",
    imgSrc: "images/weather.jpg",
    src: "https://legendary-hamster-7da601.netlify.app/",
    githubSrc: "https://github.com/Tanmoy-M17/weatherapp",
    description:
      "A weather search web application, where user will get weather based on searched cityies.",
    stack: [ "HTML", "CSS","JAVASCRIPT","API's"],
  },
];
